export const computeAutomationTooltip = (time?: number) =>
  time
    ? `Création automatique programmée à ${Math.floor(time / 100)}h${
        time % 100
      }`
    : undefined;
